import { render, staticRenderFns } from "./add-supplement-dialog.vue?vue&type=template&id=03b0db89&scoped=true"
import script from "./add-supplement-dialog.vue?vue&type=script&lang=js"
export * from "./add-supplement-dialog.vue?vue&type=script&lang=js"
import style0 from "./add-supplement-dialog.vue?vue&type=style&index=0&id=03b0db89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b0db89",
  null
  
)

export default component.exports